export default __webpack_public_path__ + "static/media/kvitanciya4.ee77b702.xls";